module.exports = __webpack_public_path__ + "static/media/sample-bank.456ecf9e.png";